import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import LoginPage from "../../authentication/pages/LoginPage";
import { UserContext } from "../hooks/UserContext";
import routes from "../models/route-constants";
import NotFoundPage from "../pages/NotFoundPage";
import HomeRouter from "./HomeRouter";
import ScrollToTop from "../components/ScrollToTop";
import LandingPage from "../pages/LandingPage";

function AppRouter({ error, signOut, firebaseAuth }) {
  const { user } = useContext(UserContext);
  const returnLoginPage = () => {
    if (!error) {
      return <LoginPage firebaseAuth={firebaseAuth} />;
    } else {
      return (
        <LoginPage
          notification={{
            message: error.message,
          }}
          firebaseAuth={firebaseAuth}
        />
      );
    }
  };
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route exact path={`/${routes.LOGIN}`}>
          {user ? <Redirect to="/" /> : returnLoginPage()}
        </Route>
        <Route path="/">
          {user ? (
            <HomeRouter user={user} signOut={signOut} />
          ) : (
            <LandingPage />
          )}
        </Route>
        <Route path="*">
          <NotFoundPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default AppRouter;
